<template>
  <div class="project-role">
    <base-table
      style="width: 40%"
      ref="table"
      url="/project/role"
      :query="query"
      :columns="columns"
      :show-pagination="false"
      :response-handler="responseHandler"
      :row-class-name="tableRowClassName"
      @row-click="rowClick"
    ></base-table>

    <el-tabs
      v-if="currentRoleid"
      style="width: 55%"
      v-model="activeName"
      class="project-role-tabs"
    >
      <el-tab-pane label="角色权限" name="roleRes">
        <resource-state-tree
          :active="active && activeName == 'roleRes'"
          :project="project"
          :roleid="currentRoleid"
          :role-name="currentRoleName"
          :save="saveRoleRes"
        ></resource-state-tree>
      </el-tab-pane>
      <el-tab-pane label="角色下属账号" name="roleUser">
        <role-user-manage2
          :active="active && activeName == 'roleUser'"
          :project="project"
          :roleid="currentRoleid"
          :role-name="currentRoleName"
          :domain="project.domain"
          :gid="currentGid"
        ></role-user-manage2>
      </el-tab-pane>
    </el-tabs>
    <div v-else style="width: 55%">
      <el-empty description="请选择角色"></el-empty>
    </div>
    <base-dialog
      :title="dialogTitle"
      v-model="showDialog"
      @ok="saveData"
      :ok-loading="saveRoleLoading"
      append-to-body
    >
      <base-form
        :init-value="false"
        v-model="formData"
        ref="form"
        :rules="rules"
        :form-items="formItems"
      ></base-form>
    </base-dialog>
    <!-- <role-user-manage
      v-model="roleUserManage.show"
      :role="roleUserManage.role"
      :project="project"
    ></role-user-manage> -->
  </div>
</template>
<script>
import { exportXlsxFile } from '../plugins/exceljs'
export default {
  name: 'project-role',
  props: {
    active: Boolean, //组件是否激活
    project: Object
  },
  computed: {
    table() {
      return this.$refs.table
    },
    form() {
      return this.$refs.form
    }
  },
  data() {
    return {
      activeName: 'roleRes',
      currentRoleid: '',
      currentRoleName: '',
      currentGid: '',
      roleUserManage: {
        show: false,
        role: {}
      },
      showDialog: false,
      dialogTitle: '添加资源',
      dialogAction: 'add',
      saveRoleLoading: false,
      formData: {},
      cuurEditData: {}, //当前修改的项
      formItems: [
        { label: '角色名称', prop: 'name', value: '' }
        // {
        //   label: '角色权限',
        //   prop: 'nress',
        //   component: 'resource-state-tree',
        //   bind: {
        //     projectid: this.project.id,
        //     role: '',
        //     ref: 'resourceStateTree'
        //   }
        // }
      ],
      rules: {
        name: [
          {
            required: true,
            message: '请输入角色名称',
            trigger: ['blur', 'change']
          },
          {
            min: 1,
            max: 25,
            message: '长度在 1 到 25 个字符',
            trigger: ['blur', 'change']
          }
        ]
      },
      query: {
        id: this.project.id,
        name: ''
      },
      columns: [
        {
          bind: { label: '角色名称', prop: 'name' },
          header: {
            component: 'cell-input',
            bind: {
              class: 'role-input',
              placeholder: '请输入角色名称',
              clearable: true
            },
            on: {
              input: this.roleInput
            }
          }
        },
        // { bind: { label: '创建时间', prop: 'cre_time', width: 150 } },
        {
          bind: { label: '操作', width: 130 },
          header: {
            component: 'cell-buttons',
            bind: {
              buttons: [
                {
                  label: '新增',
                  type: 'text',
                  size: 'mini',
                  click: (scope) => {
                    this.beginAdd()
                  }
                },
                {
                  label: '导出',
                  type: 'text',
                  size: 'mini',
                  click: (scope) => {
                    this.exportRoleAndRes()
                  }
                }
              ]
            },
            on: {
              click: (scope) => {
                this.beginAdd()
              }
            }
          },
          default: {
            component: 'cell-buttons',
            bind: {
              buttons: [
                {
                  label: '修改',
                  type: 'text',
                  click: this.beginEdit
                },
                {
                  label: '复制',
                  type: 'text',
                  click: this.beginCopy
                },
                {
                  label: '删除',
                  type: 'text',
                  click: this.delRole
                }
                // {
                //   label: '设置用户',
                //   type: 'text',
                //   click: (scope) => {
                //     this.roleUserManage.role = scope.row
                //     this.roleUserManage.show = true
                //   }
                // }
              ]
            }
          }
        }
      ]
    }
  },
  methods: {
    responseHandler(resp) {
      // this.$emit('select-role-res', [])
      var rows =
        resp.data.code == 0 && Array.isArray(resp.data.data)
          ? resp.data.data
          : []
      if (rows.length > 0) {
        this.currentRoleid = rows[0].id
        this.currentRoleName = rows[0].name
        this.currentGid = rows[0].gid
      } else {
        this.currentRoleid = ''
        this.currentRoleName = ''
        this.currentGid = ''
      }
      return {
        rows,
        total: rows.length
      }
    },
    roleInput(val) {
      this.query.name = val
      this.refreshRole()
    },
    refreshRole() {
      clearTimeout(window.refreshRoleTimeout)
      window.refreshRoleTimeout = setTimeout(() => {
        this.$refs.table.refreshData()
      }, 250)
    },
    tableRowClassName({ row, rowIndex }) {
      // console.log('tableRowClassName', rowIndex, row.id == this.currentRoleid)
      if (row.id == this.currentRoleid) {
        return 'table-row-highlight'
      }
      return ''
    },
    rowClick(row, column, event) {
      // console.log('rowClick', row.id)
      if (this.currentRoleid == row.id) {
        // this.currentRoleid = ''
        return
      }
      this.currentRoleid = row.id
      this.currentRoleName = row.name
      this.currentGid = row.gid
      // this.$post('/role/res', {
      //   id: row.id,
      //   project: this.project.id
      // }).then((resp) => {
      //   if (resp.data.code == 0) {
      //     var resIds = []
      //     for (var item of resp.data.data) {
      //       resIds.push(item.id)
      //     }
      //     this.currentRoleHaveResids = resIds
      //     // this.$emit('select-role-res', resIds)
      //   } else {
      //     this.$message(resp.data.msg || '获取该角色资源失败')
      //   }
      // })
    },
    beginAdd() {
      // this.formItems[1].bind.role = ''
      this.dialogTitle = '添加角色'
      this.dialogAction = 'add'
      this.showDialog = true
      setTimeout(() => {
        this.formData = {
          domain: this.project.domain,
          project: this.project.id,
          name: '',
          nress: []
        }
        // this.$refs.form.$refs.resourceStateTree.getProjectResource() //需要每次触发计算roles字段
      }, 100)
    },
    beginEdit(scope) {
      // this.formItems[1].bind.role = scope.row.id

      this.dialogTitle = '修改角色'
      this.dialogAction = 'edit'
      this.showDialog = true
      setTimeout(() => {
        this.cuurEditData = scope.row
        this.formData = Object.assign(
          { project: this.project.id, nress: [] },
          scope.row
        )
        // this.$refs.form.$refs.resourceStateTree.getProjectResource() //需要每次触发计算roles字段
      }, 100)
    },
    saveData() {
      this.form.validate((flag, fields) => {
        if (flag) {
          var isAdd = !this.formData.id
          var url = ''
          switch (this.dialogAction) {
            case 'add':
              url = '/role/addAndResouce'
              break
            case 'edit':
              url = '/role/updateAndResouce'
              break
            case 'copy':
              url = '/role/copyAndResouce'
              break
            default:
              this.$message('操作类型错误')
              return
          }
          this.saveRoleLoading = true
          this.$post(url, {
            parameters: JSON.stringify(this.formData)
          })
            .then((resp) => {
              this.saveRoleLoading = false
              if (resp.data.code == 0) {
                this.showDialog = false
                this.table.refreshData()
                // if (isAdd) {
                //   this.table.addRow(resp.data.data)
                // } else {
                //   this.table.updRow(this.cuurEditData, resp.data.data)
                // }
              } else {
                this.$message(resp.data.msg || '操作失败')
              }
            })
            .catch((err) => {
              console.error('保存角色发生异常=>', err)
              this.saveRoleLoading = false
              this.$message('保存角色发生异常=>' + err)
            })
        } else {
          this.$message('请填写完整')
        }
      })
    },
    delRole(scope) {
      if (confirm(`确定删除"${scope.row.name}"角色?`)) {
        this.$post('/role/remove', {
          parameters: JSON.stringify(scope.row)
        }).then((resp) => {
          if (resp.data.code == 0) {
            this.table.refreshData()
            // this.table.delRow(scope.row)
            // this.$emit('select-role-res', [])
          } else {
            this.$message(resp.data.msg || '删除失败')
          }
        })
      }
    },
    async saveRoleRes(resids, operName) {
      try {
        var resp = await this.$postObj('/role/saveResouce', {
          domain: this.project.domain,
          projectid: this.project.id,
          roleid: this.currentRoleid,
          resids
        })
        if (resp.data.code == 0) {
          this.$message({
            type: 'success',
            message: `${operName || '保存'}角色权限成功`
          })
          return true
        } else {
          this.$message(resp.data.msg || `${operName || '保存'}角色权限失败`)
        }
      } catch (err) {
        this.$message(`${operName || '保存'}角色权限发生异常=>${err.message}`)
      }
      return false
    },
    beginCopy(scope) {
      this.dialogTitle = '复制角色'
      this.dialogAction = 'copy'
      this.showDialog = true
      setTimeout(() => {
        this.formData = {
          copy_source_id: scope.row.id,
          domain: this.project.domain,
          project: this.project.id,
          name: ''
        }
      }, 100)
    },
    exportRoleAndRes() {
      this.$post('/role/exportRoleAndRes', {
        domain: this.project.domain,
        project: this.project.id
      }).then((resp) => {
        console.log('exportRoleAndRes', resp.data)
        if (resp.data.code == 0) {
          exportXlsxFile(
            `${this.project.name}_所有角色权限_${new Date().getTime()}.xlsx`,
            [
              { header: '角色名称', key: 'roleName' },
              { header: '角色权限', key: 'resTreeName' }
            ],
            {},
            resp.data.data
          )
        } else {
          this.$message(resp.data.msg || '导出失败')
        }
      })
    }
  },
  watch: {
    active: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.refreshRole()
        }
      }
    }
  }
}
</script>
<style lang="less">
.project-role {
  height: 750px;
  display: flex;
  .role-input {
    padding-left: 0;
    padding-right: 0;
    vertical-align: middle;
  }
  .project-role-tabs {
    border-left: 1px solid rgb(235, 238, 245);
    padding-left: 40px;
    margin-left: 30px;
    .el-tabs__content {
      height: calc(100% - 55px);
      .el-tab-pane {
        height: 100%;
      }
    }
  }
  // .table-row-highlight {
  //   background-color: #dde0e9;
  // }
  tr.table-row-highlight > td.el-table__cell,
  tr.table-row-highlight:hover > td.el-table__cell {
    background-color: #dde0e9;
  }
}
</style>
